import {
  PRINT_ATTENDANCE, PRINT_ATTENDANCE_SUCCESS, PRINT_ATTENDANCE_FAILURE,
  PRINT_ATTENDANCE_REMOVE_PDF, PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS, PRINT_ATTENDANCE_REMOVE_PDF_FAILURE
} from './mutation-types'

export default {
  state: {
  },
  getters: {
  },
  actions: {
    [PRINT_ATTENDANCE] ({dispatch, state, commit}, params = null) {
      var data = {}
      data = params.data
      dispatch('apiGet', {url: '/master/shift_attendances/pdf', data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PRINT_ATTENDANCE_FAILURE, res.data)
          } else {
            commit(PRINT_ATTENDANCE_SUCCESS, {data: res.data, callback: params.callback})
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PRINT_ATTENDANCE_REMOVE_PDF] ({dispatch, state, commit}, params) {
      var data = {}
      data = params.data
      setTimeout(() => {
        dispatch('apiDelete', {url: '/master/shift_attendances/remove_pdf', data: data})
          .then(res => {
            if (res.status === 200 || res.status === 304) {
              if (res.data.error) {
                commit(PRINT_ATTENDANCE_REMOVE_PDF_FAILURE, res.data)
              } else {
                commit(PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS, {
                  data: res.data,
                  callback: params.callback
                })
              }
            }
          })
          .catch(error => {
            throw error
          })
      }, 10000)
    }
  },
  mutations: {
    [PRINT_ATTENDANCE_FAILURE] (state, data) {
      console.log('PRINT_ATTENDANCE_FAILURE')
    },
    [PRINT_ATTENDANCE_SUCCESS] (state, data) {
      console.log('PRINT_ATTENDANCE_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    },
    [PRINT_ATTENDANCE_REMOVE_PDF_FAILURE] (state, data) {
      console.log('PRINT_ATTENDANCE_REMOVE_PDF_FAILURE')
    },
    [PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS] (state, data) {
      console.log('PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS')
      if (data.callback) {
        data.callback(data.data)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/shift-attendance.js